<template>
    <div class="my-6">
        <button
            class="
                bg-primary
                rounded-lg
                py-2
                px-3
                text-white text-xs
                flex
                items-center
                gap-2
            "
            @click="state.isCreateMode = true"
            v-if="!state.isCreateMode && !state.isEditMode"
        >
            <ion-icon name="add-outline"></ion-icon>
            Add New Package
        </button>
        <div v-if="state.isCreateMode" class="flex gap-2 items-center w-full">
            <input
                v-model="state.packageName"
                class="bg-gray-100 rounded-lg py-2 px-3 text-xs w-full"
                placeholder="Package Name"
            />

            <button
                class="
                    bg-primary
                    rounded-lg
                    py-2
                    px-3
                    text-white text-xs
                    flex
                    items-center
                    gap-1
                "
                @click="create"
            >
                <ion-icon name="save-outline"></ion-icon>
                Save
            </button>
            <button
                class="
                    bg-gray-400
                    rounded-lg
                    py-2
                    px-3
                    text-white text-xs
                    flex
                    items-center
                    gap-1
                "
                @click="state.isCreateMode = false"
            >
                <ion-icon name="close-outline"></ion-icon>
                Cancel
            </button>
        </div>
        <table class="mt-6" v-if="state.packages.length">
            <tbody>
                <tr
                    v-for="pkg in state.packages"
                    :key="pkg.id"
                    class="border-b border-gray-200"
                >
                    <td class="text-left text-sm p-2 w-[100%]">
                        <span v-if="state.isEditMode !== pkg.id">
                            {{ pkg.name }}
                        </span>
                        <div v-else class="flex gap-2">
                            <input
                                v-model="state.packageName"
                                class="
                                    bg-gray-100
                                    rounded-lg
                                    py-2
                                    px-3
                                    text-xs
                                    w-full
                                "
                                placeholder="Package Name"
                            />

                            <button
                                class="
                                    bg-primary
                                    rounded-lg
                                    py-2
                                    px-3
                                    text-white text-xs
                                    flex
                                    items-center
                                    gap-1
                                "
                                @click="update(pkg)"
                            >
                                <ion-icon name="save-outline"></ion-icon>
                                Save
                            </button>
                            <button
                                class="
                                    bg-gray-400
                                    rounded-lg
                                    py-2
                                    px-3
                                    text-white text-xs
                                    flex
                                    items-center
                                    gap-1
                                "
                                @click="state.isEditMode = null"
                            >
                                <ion-icon name="close-outline"></ion-icon>
                                Cancel
                            </button>
                        </div>
                    </td>
                    <td class="text-left">
                        <a
                            class="text-primary text-sm cursor-pointer"
                            @click="edit(pkg)"
                            >Edit</a
                        >
                    </td>
                    <td class="text-left">
                        <a
                            class="text-red-500 text-sm ml-2 cursor-pointer"
                            @click="destroy(pkg)"
                            >Delete</a
                        >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import { defineProps, reactive, onMounted } from "vue";
import emitter from "tiny-emitter/instance";

const props = defineProps({
    teamId: {
        type: Number,
    },
});

const state = reactive({
    packages: [],
    packageName: "",
    isCreateMode: false,
    isEditMode: null,
});

async function notifyUpdated() {
    const data = await getData();
    emitter.emit("package-updated", data);
}

async function getData() {
    const teamId = props.teamId ? props.teamId : "";
    state.packages = (await axios.get(`/package?teamId=${teamId}`)).data;
    return state.packages;
}

function edit(pkg) {
    state.isEditMode = pkg.id;
    state.packageName = pkg.name;
}

async function create() {
    await axios.post("/package", {
        name: state.packageName,
        teamId: props.teamId,
    });
    state.packageName = "";
    state.isCreateMode = false;
    notifyUpdated();
}
async function update(pkg) {
    await axios.post(`/package/${pkg.id}/update`, {
        name: state.packageName,
    });
    state.packageName = "";
    state.isEditMode = null;
    notifyUpdated();
}

async function destroy(pkg) {
    await axios.post(`/package/${pkg.id}/delete`);
    notifyUpdated();
}

onMounted(() => {
    getData();
});
</script>
